import { render, staticRenderFns } from "./LessonsTableHeader.vue?vue&type=template&id=3c1486df&"
import script from "./LessonsTableHeader.vue?vue&type=script&lang=js&"
export * from "./LessonsTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./LessonsTableHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
